import BSProductsSubmitted from 'views/WIC/BSProductsSubmitted'
import BSProductsPending from 'views/WIC/BSProductsPending'
import BSProductsReviewed from 'views/WIC/BSProductsReviewed'
import NBSProductsSubmitted from 'views/WIC/NBSProductsSubmitted'
import NBSProductsPending from 'views/WIC/NBSProductsPending'
import NBSProductsReviewed from 'views/WIC/NBSProductsReviewed'
import Reports from 'views/WIC/Reports'
// import MyProfile from 'views/pages/MyProfile'

const wicRoutes = [
  {
    path: null,
    name: 'Any Brand',
    // icon: 'fas fa-ban',
    component: null,
    layout: '/submission',
    header: true,
  },
  {
    path: '/dashboard',
    name: 'Products Pending - Reviewer 1',
    // icon: 'nc-icon nc-tile-56',1
    // icon: 'far fa-circle',
    component: NBSProductsSubmitted,
    layout: '/submission',
  },
  // {
  //   path: '/my-profile',
  //   name: 'My Profile',
  //   // icon: 'far fa-circle',
  //   component: MyProfile,
  //   layout: '/submission',
  // },
  {
    path: '/any-brand-inreview',
    name: 'Products Pending - Reviewer 2',
    // icon: 'nc-icon nc-bulb-63',
    // icon: 'far fa-circle',
    component: NBSProductsPending,
    layout: '/submission',
  },
  {
    path: '/any-brand-reviewed',
    name: 'Products Reviewed',
    // icon: 'nc-icon nc-bulb-63',
    // icon: 'far fa-circle',
    component: NBSProductsReviewed,
    layout: '/submission',
  },
  {
    path: null,
    name: 'Brand Specific',
    // icon: 'fas fa-ban',
    component: null,
    layout: '/submission',
    header: true,
  },
  {
    path: '/brand-specific-submitted',
    name: 'Products Pending - Reviewer 1',
    // icon: 'nc-icon nc-tile-56',1
    // icon: 'far fa-circle',
    component: BSProductsSubmitted,
    layout: '/submission',
  },
  {
    path: '/brand-specific-inreview',
    name: 'Products Pending - Reviewer 2',
    // icon: 'nc-icon nc-bulb-63',
    // icon: 'far fa-circle',
    component: BSProductsPending,
    layout: '/submission',
  },
  {
    path: '/brand-specific-reviewed',
    name: 'Products Reviewed',
    // icon: 'nc-icon nc-bulb-63',
    // icon: 'far fa-circle',
    component: BSProductsReviewed,
    layout: '/submission',
  },
  {
    path: null,
    name: 'Reports',
    // icon: 'fas fa-ban',
    component: null,
    layout: '/submission',
    header: true,
  },
  {
    path: '/reports',
    name: 'Reports',
    // icon: 'nc-icon nc-bulb-63',
    // icon: 'far fa-circle',
    component: Reports,
    layout: '/submission',
  },
  // Pages for feature to be implemented in the future
  //
  // {
  //   path: '/vendor-page',
  //   name: 'Contacts',
  //   // icon: 'nc-icon nc-single-02',
  //   // icon: 'far fa-circle',
  //   component: SubmitterPage,
  //   layout: '/submission',
  // },
  // {
  //   path: '/logout',
  //   name: 'Log Out',
  //   // icon: 'fas fa-sign-out-alt',
  //   component: LogoutPage,
  //   layout: '/auth',
  // },
]

export default wicRoutes
